import type { ProjectItem } from '@store/reducers/dashboard/types'

import { DAY_MONTH_YEAR, HOUR_MINUTE_AM_PM } from '@/constants/constants'
import { useAuth } from '@/hooks'
import { toDateTime } from '../utils'

// The text a project is listed with: the same in the tile and in the row.
export const useProjectLabel = (project: ProjectItem) => {
  const user = useAuth()

  const dateFormat = user.dateFormat === DAY_MONTH_YEAR
  const timeFormat = user.timeFormat === HOUR_MINUTE_AM_PM

  // For a report, updatedAt is the last crawl, not a canvas edit — the label
  // reads the same field either way.
  const updated = toDateTime(project.updatedAt, false, dateFormat, timeFormat)

  const title =
    project.type === 'report' && project.domain ? project.domain : project.title

  return { title, updated }
}
